<template>
  <div
    class="course-info-area"
    :class="{ 'h5-course-info': isH5, 'electron-course-info': isElectron, 'sidebar-collapsed': collapsed }"
  >
    <template v-if="!justShowTabList">
      <p class="lesson-name" v-if="isH5 && activeTab === 'desc'">
        {{ lessonInfo.lesson_name || "" }}
      </p>
      <div class="org-name" v-if="(isH5 && activeTab === 'desc') || !isH5">
        <!-- <img
          :src="cdnUrl + courseInfo.org_logo + '?imageView2/0/w/700'"
          alt=""
        /> -->
        <safe-image
          class="org-logo"
          :src="cdnUrl + courseInfo.org_logo + '?imageView2/0/w/700'"
          alt=""
        />
        <div class="name" @click="goOrgHome">{{ courseInfo.org_name }}</div>
      </div>
    </template>
    <div class="course-wrap">
      <template v-if="!justShowTabList">
        <div class="course-info" v-if="(isH5 && activeTab === 'desc') || !isH5">
          <div class="top">
            <!-- <img :src="courseInfo.cover_url + '?imageView2/0/w/700'" alt="" /> -->
            <safe-image
              class="course-cover"
              :src="courseInfo.cover_url + '?imageView2/0/w/700'"
              alt=""
            />
            <div class="name-info">
              <div class="name">{{ courseInfo.course_name }}</div>
              <!-- <div class="lesson_count">共 {{ courseInfo.lesson_count }} 课时</div> -->
            </div>
          </div>
          <div class="bottom">
            <div class="price-info" v-if="!courseInfo.enrollment">
              <template v-if="courseInfo.goods?.fee_type !== 1">
                <!-- 促销价 -->
                <template v-if="courseInfo.activity_type === 2">
                  <div class="price">
                    <span>¥</span
                    >{{ courseInfo.promotion_info?.promotion_price / 100 }}
                  </div>
                  <div class="origin-price">
                    ¥ {{ courseInfo.goods?.price / 100 }}
                  </div>
                </template>
                <template v-else>
                  <div class="price">
                    <span>¥</span>{{ courseInfo.goods?.price / 100 }}
                  </div>
                </template>
              </template>
              <template v-else>
                <div class="price">免费</div>
              </template>
            </div>
            <div class="buy-btn-wrap">
              <div
                v-if="!courseInfo.enrollment"
                class="buy-btn"
                @click="goCourseDetail"
              >
                {{ courseInfo.enrollment ? "进入课程" : "了解课程" }}
              </div>
              <div v-else class="arrow-btn" @click="goCourseDetail">
                <img
                  src="@saas/pages/assets/images/course-card/arrow.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- tab -->
      <ul v-if="!isH5" class="tab-list">
        <li
          @click="changeActiveTab(item)"
          :class="{ active: item.type === lessonType }"
          v-for="item in tabList"
          :key="item.id"
        >
          {{ item.name }}
        </li>
        <li
          v-if="showSidebarToggle"
          class="sidebar-toggle"
          @click="$emit('toggleSidebar')"
        >
          收起
        </li>
      </ul>
      <div
        class="lesson-list"
        v-if="
          ((isH5 && activeTab === 'folder') || !isH5) &&
          lessonType === 'normal' &&
          false
        "
      >
        <el-collapse
          v-model="activeNames"
          @change="handleChange"
          class="collapse-wrap"
        >
          <el-collapse-item
            v-for="unit in unitList"
            :key="unit.id"
            :title="unit.unit_name"
            :name="unit.id"
          >
            <template slot="title">
              <div class="unit-name">{{ unit.unit_name }}</div>
            </template>
            <template v-if="unit.lesson_list && unit.lesson_list.length">
              <div class="lesson-list-wrap">
                <div
                  class="lesson-item"
                  :class="{
                    'active-lesson-item': lesson.id === activeLesson.id,
                  }"
                  v-for="lesson in unit.lesson_list"
                  :key="lesson.id"
                  @click="handleClickLesson(lesson)"
                >
                  <div class="icon">
                    <span
                      v-if="lesson.canTrial && !isRegistered"
                      class="lesson-type-tag can-trial"
                      >试学</span
                    >
                    <!-- 直播课 -->
                    <template v-else-if="lesson.lesson_type === 2">
                      <span
                        v-if="lesson.roomStatus === 2"
                        class="lesson-type-tag living"
                      >
                        <img src="../../../assets/images/living-tag.gif" alt=""
                      /></span>
                      <span
                        v-else
                        class="lesson-type-tag"
                        :class="{ 'live-tag': lesson.liveStatus !== 1 }"
                        >{{
                          [1].includes(lesson.liveStatus) ? "视频" : "直播"
                        }}</span
                      >
                    </template>
                    <!-- 点播/音频/未知课时 -->
                    <template v-else>
                      <span
                        class="lesson-type-tag"
                        :class="getLessonTagClass(lesson)"
                        >{{ getLessonTagText(lesson) }}</span
                      >
                    </template>
                  </div>
                  <div class="lesson-info">
                    <div class="name">{{ lesson.lesson_name }}</div>
                    <div class="other">
                      <div class="teacher" v-if="lesson.org_nickname">
                        {{ lesson.org_nickname }}
                      </div>
                      <div class="lesson-time">
                        {{ handleDuration(lesson.duration) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div :key="lessonType" class="tab-content-enter">
        <LessonList
          v-if="
            (isH5 && activeTab === 'folder') || (!isH5 && lessonType === 'normal')
          "
          @changeLesson="handleClickLesson"
          :unitList="unitList"
          :activeLesson="activeLesson"
          :isRegistered="isRegistered"
        />
        <LessonList
          v-if="
            (isH5 && activeTab === 'private') ||
            (!isH5 && lessonType === 'private')
          "
          @changeLesson="handleClickLesson"
          :unitList="privateUnitList"
          :activeLesson="activeLesson"
        />
        <notes
          :componentId="noteComponentId"
          class="notes-container"
          v-if="!isH5 && lessonType === 'notes'"
          :lesson-info="lessonInfo"
          :notesPlaceholder="notesPlaceholder"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@saas/components/src/utils/event-bus";
import LessonList from "./LessonList";
import { isH5, isHXApp, isMobile } from "@saas/components/src/utils/utils";
import Notes from "./Notes";
import moment from "moment";
import {
  LESSON_TYPES,
  getLessonTypeConfig,
  isAudioLessonType,
  isKnownLessonType,
  isOnDemandLessonType,
} from "@saas/components/src/utils/lesson-type";
export default {
  props: {
    noteComponentId: {
      type: [String, Number],
      default: null,
    },
    justShowTabList: {
      type: Boolean,
      default: false,
    },
    lessonInfo: {
      type: Object,
      default: () => ({}),
    },
    courseInfo: {
      type: Object,
      default: () => ({}),
    },
    activeTab: {
      type: String,
      default: "desc",
    },
    havePrivateLesson: {
      type: Number,
      default: 0,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
    showSidebarToggle: {
      type: Boolean,
      default: true,
    },
    notesPlaceholder: {
      type: String,
      default: "请填写您的笔记",
    },
  },
  data() {
    return {
      isMobile: isMobile(),
      // tabList: [
      //   {
      //     id: 1,
      //     name: "目录",
      //     type: "normal",
      //   },
      //   {
      //     id: 2,
      //     name: "私教课",
      //     type: "private",
      //   },
      // ],
      lessonType: "normal",
      activeLesson: {},
      activeNames: [],
      moment,
      cdnUrl: process.env.VUE_APP_CDN_URL,
      isH5: isH5(),
      isElectron: window.isElectron,
    };
  },
  mounted() {
    this.offEvents();
    this.registerEvents();
  },
  watch: {
    courseInfo: {
      handler(val) {
        if (val && val.unit_list && val.unit_list.length) {
          this.activeNames = val.unit_list.map((item) => item.id);
        } else {
          this.activeNames = [];
        }
      },
      immediate: true,
      deep: true,
    },
    lessonInfo: {
      handler(val) {
        if (val && val.id) {
          this.activeLesson = {
            // id: val.lesson_id,
            ...val,
          };
          if (val.isPrivate) {
            this.lessonType = "private";
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    tabList() {
      let list = [
        {
          id: 1,
          name: "目录",
          type: "normal",
        },
        { id: 3, name: "笔记", type: "notes" },
      ];
      if (this.havePrivateLesson) {
        list.splice(1, 0, {
          id: 2,
          name: "私教课",
          type: "private",
        });
      }
      return list;
    },
    // 课程详情数据
    unitList() {
      if (this.courseInfo.unit_list && this.courseInfo.unit_list.length) {
        return this.courseInfo.unit_list.map((unit) => {
          if (unit.lesson_list && unit.lesson_list.length) {
            const lessonList = unit.lesson_list.filter((lesson) => {
              lesson.lessonTypeConfig = getLessonTypeConfig(
                lesson.lesson_type
              );
              lesson.lessonTypeLabel = lesson.lessonTypeConfig.label;
              return (
                [
                  LESSON_TYPES.ON_DEMAND,
                  LESSON_TYPES.LIVE,
                  LESSON_TYPES.AUDIO,
                ].includes(lesson.lesson_type) ||
                !lesson.lessonTypeConfig.isKnown
              );
            });
            lessonList.forEach((lesson) => {
              if (lesson.lesson_type === 2) {
                // 直播课状态处理
                this.handleLiveStatus(lesson);
                // 处理直播间状态
                this.handleRoomStatus(lesson);
                // 提示信息处理
                this.handleLiveTips(lesson);
              }
              // 是否可试听-直播或点播
              if (
                lesson.lessonTypeConfig.canTrial &&
                lesson.trial_duration != 0
              ) {
                // 可试听
                lesson.canTrial = 1;
              }
            });
            return {
              ...unit,
              lesson_list: lessonList,
            };
          } else {
            return unit;
          }
        });
      } else {
        return [];
      }
    },
    // 私教列表
    privateUnitList() {
      if (this.courseInfo?.private_unit_list?.length) {
        return this.courseInfo?.private_unit_list.map((unit) => {
          if (unit?.lesson_list?.length) {
            let lessonList = unit?.lesson_list.filter(
              (lesson) => lesson.lesson_type === 4
            );
            lessonList.forEach((lesson) => {
              if (lesson.lesson_type === 4) {
                // 直播课状态处理
                this.handleLiveStatus(lesson);
                // 处理直播间状态
                this.handleRoomStatus(lesson);
                // 提示信息处理
                this.handleLiveTips(lesson);
                // 老师列表
                let arr = [];
                (lesson?.assistant || []).forEach((assistant) => {
                  arr.push(assistant.org_nickname);
                });
                lesson.teachers = arr.join("、");
              }
            });
            return {
              ...unit,
              lesson_list: lessonList,
            };
          } else {
            return unit;
          }
        });
      } else {
        return [];
      }
    },
    // 是否报名
    isRegistered() {
      return this.courseInfo.enrollment !== null;
    },
  },
  methods: {
    offEvents() {
      EventBus.$off("video-play-page-change-tab-to-note");
    },
    registerEvents() {
      EventBus.$on(
        "video-play-page-change-tab-to-note",
        this.changeActiveTabToNote
      );
    },
    changeActiveTabToNote(data) {
      this.lessonType = "notes";
      setTimeout(() => {
        if (data.type === "screenshot") {
          EventBus.$emit(
            `handle-insert-video-screen-shot-${data.noteComponentId}`,
            {
              ...data,
              url: "",
            }
          );
        } else {
          const { id, time, title, file, type } = data;
          EventBus.$emit(`handle-insert-mark-block-${data.noteComponentId}`, {
            type,
            time,
            content: title,
            file,
            imgUrl: "",
          });
        }
      }, 100);
    },
    changeActiveTab({ type }) {
      this.lessonType = type;
    },
    handleLiveTips(lesson) {
      if (lesson.record_url) {
        lesson.liveStatus = 1;
        lesson.tips = "观看视频";
      } else if (lesson.roomStatus === 3) {
        lesson.liveStatus = 2;
        lesson.tips = "回放生成中";
      } else if (lesson.status === 2 || lesson.roomStatus === 2) {
        // 直播间开始上课|到后台设置的课程开始时间
        lesson.liveStatus = 3;
        lesson.tips = "进入教室";
      } else if (lesson.status === 1 && lesson.first_join_time) {
        lesson.liveStatus = 4;
        lesson.tips = `提前${lesson.first_join_time}分钟才可进入`;
      }
    },
    handleLiveStatus(item) {
      let begin = item.live_start_time;
      let end = item.live_end_time;
      let now = new Date().getTime();
      // 可提前进入
      if (item.first_join_time) {
        begin = begin - item.first_join_time * 60;
      }
      if (end * 1000 < now) {
        // 已结束
        item.status = 3;
      } else if (begin * 1000 > now) {
        // 未开始
        item.status = 1;
      } else {
        // 已开始
        item.status = 2;
      }
    },
    getLessonTagClass(lesson) {
      if (isOnDemandLessonType(lesson.lesson_type)) {
        return "saas-demand-color";
      }
      if (isAudioLessonType(lesson.lesson_type)) {
        return "audio-tag";
      }
      if (!isKnownLessonType(lesson.lesson_type)) {
        return "unknown-tag";
      }
      return "";
    },
    getLessonTagText(lesson) {
      return getLessonTypeConfig(lesson.lesson_type).listLabel;
    },
    // 处理直播间状态
    handleRoomStatus(item) {
      let { room_start_time, room_end_time } = item;
      if (room_start_time > 0 && !room_end_time) {
        item.roomStatus = 2;
        item.roomStatusText = "上课中";
      } else if (room_end_time > 0) {
        item.roomStatus = 3;
        item.roomStatusText = "已下课";
      } else {
        item.roomStatus = 1;
        item.roomStatusText = "未开始";
      }
    },
    getIconUrl(lessonType, lesson) {
      if (+lessonType === 1) {
        return this.demandIcon;
      } else if (+lessonType === 2) {
        if (lesson.room_end_time) {
          return this.recordIcon;
        } else {
          return this.liveIcon;
        }
      } else if (+lessonType === 5) {
        return this.audioIcon || "";
      } else {
        return "";
      }
    },
    // 进入课程详情
    goCourseDetail() {
      if (window.isElectron || this.isMobile) {
        this.$router.push(`/product-detail/${this.courseInfo.id}`);
      } else {
        window.open(`/product-detail/${this.courseInfo.id}`);
      }
    },
    // 进入机构主页
    goOrgHome() {
      if (window.isElectron || this.isMobile) {
        this.$router.push(`/org/${this.courseInfo.org_id}`);
      } else {
        window.open(`/org/${this.courseInfo.org_id}`);
      }
    },
    handleChange() {},

    // 点击课时
    handleClickLesson(lesson) {
      this.activeLesson = lesson;
      this.$emit("changeLesson", lesson);
    },
  },
  components: {
    LessonList,
    Notes,
  },
};
</script>

<style scoped lang="scss">
.tab-list {
  display: flex;
  align-items: center;
  padding: 12px 0 0 20px;
  li {
    font-size: 14px;
    color: #515350;
    line-height: 20px;
    padding-bottom: 4px;
    cursor: pointer;
    margin-right: 24px;
  }
  .active {
    font-weight: 600;
    font-size: 14px;
    color: #0d1400;
    line-height: 20px;
    position: relative;
    &::after {
      position: absolute;
      content: "";
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 8px;
      height: 2px;
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      border-radius: 1px;
    }
  }
  .sidebar-toggle {
    margin-left: auto !important;
    margin-right: 0 !important;
    padding-right: 16px;
    font-size: 12px !important;
    color: #86909c !important;
    font-weight: 400 !important;
    &:hover {
      color: #00c89d !important;
    }
  }
}
.course-info-area {
  width: 300px;
  height: 100%;
  margin-left: 18px;
  background: rgba(227, 248, 235, 0.6);
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  overflow: hidden;
  transition: width 0.3s ease, opacity 0.3s ease, margin-left 0.3s ease;

  &.sidebar-collapsed {
    width: 0;
    opacity: 0;
    margin-left: 0;
    padding: 0;
    border: none;
    box-shadow: none;
  }
  .org-name {
    display: flex;
    align-items: center;
    padding-left: 10px;
    height: 60px;
    // background: linear-gradient(
    //   135deg,
    //   rgba(244, 255, 248, 0.8) 0%,
    //   rgba(254, 254, 255, 0.8) 87%,
    //   rgba(249, 251, 255, 0.8) 100%
    // );
    border-radius: 6px;
    border: 1px solid #ffffff;
    .org-logo {
      width: 40px;
      height: 40px;
      margin-right: 8px;
      background-color: #fff;
      border-radius: 8px;
    }
    .name {
      cursor: pointer;
      flex: 1;
      font-weight: 400;
      font-size: 16px;
      color: #0d1400;
      word-break: break-all;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .course-wrap {
    flex: 1;
    min-height: 0;
    // background: RGBA(238, 249, 243, 1);
    margin-top: 9px;
    border-radius: 6px;
    border: 1px solid #ffffff;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .course-info {
      // background: rgba(244, 252, 247, 0.8);
      border-bottom: 1px solid #ffffff;
      padding: 14px;
      .top {
        display: flex;
        flex-direction: row;
        // img {
        //   width: 101px;
        //   height: 58px;
        //   border-radius: 6px;
        //   background-color: #a9a9a9;
        //   object-fit: cover;
        // }
        .course-cover {
          width: 101px;
          height: 58px;
          border-radius: 6px;
          background-color: #a9a9a9;
          object-fit: cover;
        }
        .name-info {
          flex: 1;
          margin-left: 6px;
          .name {
            height: 38px;
            font-weight: 500;
            font-size: 14px;
            color: #0d1400;
            line-height: 18px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
          }
          .lesson_count {
            margin-top: 3px;
            font-size: 12px;
            color: #515350;
            line-height: 17px;
          }
        }
      }
      .bottom {
        display: flex;
        align-items: center;
        margin-top: 4px;
        .price-info {
          flex: 1;
          display: flex;
          align-items: center;
          .price {
            color: #f03349;
            font-weight: 600;
            font-size: 20px;
            span {
              font-size: 12px;
            }
          }
          .origin-price {
            margin-left: 8px;
            text-decoration: line-through;
            font-weight: 400;
            font-size: 14px;
            color: #858687;
            line-height: 22px;
          }
        }
        .buy-btn-wrap {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          .buy-btn {
            cursor: pointer;
            width: 80px;
            height: 28px;
            line-height: 28px;
            text-align: center;
            background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
            border-radius: 6px;
            font-weight: 500;
            font-size: 14px;
            color: #ffffff;
          }
          .arrow-btn {
            cursor: pointer;
            width: 28px;
            height: 28px;
            line-height: 28px;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              width: 8px;
              height: 5px;
              transform: rotate(-90deg);
            }
          }
        }
      }
    }
    .lesson-list {
      padding: 12px 8px 12px 12px;
      margin-right: 4px;
      flex: 1;
      min-height: 0;
      overflow: auto;
      &::-webkit-scrollbar {
        width: 5px;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      &::-webkit-scrollbar-thumb {
        background: rgba(148, 163, 184, 0.2);
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb:hover {
        background: rgba(148, 163, 184, 0.4);
      }
      .collapse-wrap ::v-deep {
        border: none;
        .el-collapse-item {
          margin-bottom: 12px;
          &:last-child {
            margin-bottom: 0;
          }
          .el-collapse-item__header {
            border: none;
            font-weight: 500;
            font-size: 14px;
            height: 38px;
            color: #0d1400;
            padding-left: 14px;
            background: unset;
            background: RGBA(243, 252, 247, 1);
            border-radius: 6px;

            .unit-name {
              word-break: break-all;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: space-between;
            }
            i {
              color: #0d1400;
              font-size: 12px;
              font-weight: bold;
            }
          }
          .el-collapse-item__wrap {
            background: unset;
            border: none;
            .el-collapse-item__content {
              padding: 0;
            }
          }
        }
      }
      .lesson-list-wrap {
        .lesson-item {
          cursor: pointer;
          box-sizing: border-box;
          width: 100%;
          height: 65px;
          padding: 12px 12px 12px 4px;
          display: flex;
          align-items: flex-start;
          border-bottom: 1px solid #ffffff;
          border-radius: 6px;
          border: 1px solid rgba(0, 200, 157, 0);
          .lesson-info {
            flex: 1;
            overflow: hidden;
            .name {
              width: 100%;
              font-weight: 400;
              font-size: 14px;
              color: #0d1400;
              line-height: 18px;
              word-break: break-all;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .other {
              margin-top: 8px;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              .teacher {
                font-weight: 400;
                font-size: 12px;
                color: #515350;
                line-height: 17px;
                word-break: break-all;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                margin-right: 21px;
              }
              .lesson-time {
                font-weight: 400;
                font-size: 12px;
                color: #515350;
                line-height: 17px;
              }
            }
          }
        }
        .active-lesson-item {
          border: 1px solid rgba(0, 200, 157, 0.2);
          background: linear-gradient(
            133deg,
            rgba(230, 254, 241, 0.9) 0%,
            rgba(206, 255, 228, 0.9) 100%
          );
        }
      }
    }
    .lesson-list::-webkit-scrollbar {
      width: 5px;
    }
    .lesson-list::-webkit-scrollbar-track {
      background: transparent;
    }
    .lesson-list::-webkit-scrollbar-thumb {
      background: rgba(148, 163, 184, 0.2);
      border-radius: 10px;
    }
    .lesson-list::-webkit-scrollbar-thumb:hover {
      background: rgba(148, 163, 184, 0.4);
    }
    .notes-container {
      flex: 1;
      min-height: 0;
      overflow: auto;
      &::-webkit-scrollbar {
        width: 5px;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      &::-webkit-scrollbar-thumb {
        background: rgba(148, 163, 184, 0.2);
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb:hover {
        background: rgba(148, 163, 184, 0.4);
      }
    }
  }
}
.h5-course-info {
  // 课程类型标签
  .lesson-type-tag {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.11rem;
    border: 0.01rem solid #efefef;
    font-weight: 400;
    font-size: 0.29rem;
    color: #747573;
    line-height: 1;
    padding: 0.1rem 0.11rem 0.09rem;
    background: transparent;
    width: auto;
    &.live-tag {
      color: #00c89d;
      border: 0.01rem solid #b8e7dd;
    }
    &.can-trial {
      color: #f03349;
      border: 0.01rem solid #feadb7;
    }
    &.audio-tag {
      color: #00c89d;
      border: 0.01rem solid #b8e7dd;
      background: rgba(0, 200, 157, 0.05);
    }
    &.unknown-tag {
      color: #64748b;
      border: 0.01rem dashed #cbd5e1;
      background: #f8fafc;
    }
    &.living {
      width: 0.8rem;
      border: 0.01rem solid #b8e7dd;
      padding-top: 0.08rem;
      padding-bottom: 0.08rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  width: 100%;
  padding: 0 0.32rem;
  margin: 0;
  .lesson-name {
    font-weight: 500;
    font-size: 0.4267rem;
    color: #0d1400;
    line-height: 0.5867rem;
    margin-bottom: 0.3733rem;
  }
  .org-name {
    margin-bottom: 0.2667rem;
    display: flex;
    align-items: center;
    padding-left: 0.3733rem;
    height: 60px;
    background: linear-gradient(
      135deg,
      rgba(244, 255, 248, 0.8) 0%,
      rgba(254, 254, 255, 0.8) 87%,
      rgba(249, 251, 255, 0.8) 100%
    );
    border-radius: 0.2133rem;
    border: 1px solid #ffffff;
    .org-logo {
      width: 0.96rem;
      height: 0.96rem;
      margin-right: 0.2667rem;
      background-color: #fff;
      border-radius: 0.2133rem;
    }
    .name {
      cursor: pointer;
      flex: 1;
      font-weight: 400;
      font-size: 0.4267rem;
      color: #0d1400;
      word-break: break-all;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .course-wrap {
    margin-top: 0.2667rem;
    background: rgba(227, 248, 235, 0.6);
    border-radius: 0.2133rem;
    border: none;
    margin-bottom: 0.4267rem;
    .course-info {
      background: rgba(244, 252, 247, 0.8);
      border-bottom: 1px solid #ffffff;
      padding: 0.3733rem;
      .top {
        display: flex;
        flex-direction: row;
        .course-cover {
          width: 2.6933rem;
          height: 1.5467rem;
          border-radius: 0.16rem;
          background-color: #a9a9a9;
        }
        .name-info {
          flex: 1;
          margin-left: 0.16rem;
          .name {
            height: 0.96rem;
            font-weight: 500;
            font-size: 0.3733rem;
            color: #0d1400;
            line-height: 0.48rem;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .lesson_count {
            margin-top: 0.08rem;
            font-size: 0.32rem;
            color: #515350;
            line-height: 0.4533rem;
          }
        }
      }
      .bottom {
        display: flex;
        align-items: center;
        margin-top: 0.1067rem;
        .price-info {
          flex: 1;
          display: flex;
          align-items: center;
          .price {
            color: #f03349;
            font-weight: 600;
            font-size: 0.5333rem;
            span {
              font-size: 0.32rem;
            }
          }
          .origin-price {
            margin-left: 0.2133rem;
            text-decoration: line-through;
            font-weight: 400;
            font-size: 0.3733rem;
            color: #858687;
            line-height: 0.5867rem;
          }
        }
        .buy-btn-wrap {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          .buy-btn {
            cursor: pointer;
            width: 2.1333rem;
            height: 0.7467rem;
            line-height: 0.7467rem;
            text-align: center;
            background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
            border-radius: 0.16rem;
            font-weight: 500;
            font-size: 0.3733rem;
            color: #ffffff;
          }
        }
      }
    }
    .lesson-list {
      // padding: 12px 14px;
      padding: 0;
      .collapse-wrap ::v-deep {
        border: none;
        .el-collapse-item {
          margin-bottom: 0.3733rem;
          .el-collapse-item__header {
            font-weight: 500;
            font-size: 0.4267rem;
            color: #0d1400;
            padding-left: 0.3733rem;
            background: unset;
            background: rgba(244, 252, 247, 0.8);
            border-radius: 0.16rem;

            .unit-name {
              word-break: break-all;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              flex: 1;
            }
            i {
              color: #0d1400;
              font-size: 0.24rem;
            }
          }
          .el-collapse-item__wrap {
            background: unset;
            .el-collapse-item__content {
              padding: 0;
            }
          }
        }
      }
      .lesson-list-wrap {
        .lesson-item {
          cursor: pointer;
          box-sizing: border-box;
          width: 100%;
          height: 2.08rem;
          padding: 0.3733rem 0.3733rem 0.3733rem 0.0533rem;
          display: flex;
          align-items: flex-start;
          border-bottom: 1px solid #ffffff;
          border-radius: 0.16rem;
          border: 1px solid rgba(0, 200, 157, 0);
          .lesson-info {
            flex: 1;
            overflow: hidden;
            .name {
              width: 100%;
              font-weight: 400;
              font-size: 0.4267rem;
              color: #0d1400;
              line-height: 0.5867rem;
              word-break: break-all;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .other {
              margin-top: 0.2133rem;
              display: flex;
              flex-direction: row;
              align-items: center;
              .teacher {
                font-weight: 400;
                font-size: 0.3733rem;
                color: #515350;
                line-height: 0.5333rem;
                word-break: break-all;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                margin-right: 0.56rem;
              }
              .lesson-time {
                font-size: 0.3733rem;
                color: #515350;
                line-height: 0.5333rem;
              }
            }
          }
        }
        .active-lesson-item {
          border: 1px solid rgba(0, 200, 157, 0.2);
          background: linear-gradient(
            133deg,
            rgba(230, 254, 241, 0.9) 0%,
            rgba(206, 255, 228, 0.9) 100%
          );
        }
      }
    }
  }
}

// electron
.course-info-area.electron-course-info {
  width: 400px;
  margin-left: 11px;
}
@keyframes fadeSlideIn {
  from {
    opacity: 0;
    transform: translateX(8px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.tab-content-enter {
  flex: 1;
  min-height: 0;
  overflow: clip;
  display: flex;
  flex-direction: column;
  animation: fadeSlideIn 0.25s cubic-bezier(0.2, 0.8, 0.2, 1) forwards;
}
</style>
